const VERIFIER_KEY = 'iland.auth.pkceVerifier';
const STATE_KEY = 'iland.auth.oauthState';
const RETURN_TO_KEY = 'iland.auth.returnTo';

const base64Url = (bytes: Uint8Array): string => {
  let binary = '';
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

const randomString = (): string => base64Url(window.crypto.getRandomValues(new Uint8Array(32)));

export const createPkceChallenge = async (): Promise<{ verifier: string; challenge: string }> => {
  const verifier = randomString();
  const digest = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
  return { verifier, challenge: base64Url(new Uint8Array(digest)) };
};

export const createState = (): string => randomString();

export const rememberFlow = (verifier: string, state: string, returnTo: string): void => {
  window.sessionStorage.setItem(VERIFIER_KEY, verifier);
  window.sessionStorage.setItem(STATE_KEY, state);
  window.sessionStorage.setItem(RETURN_TO_KEY, returnTo);
};

export const takeFlow = (): { verifier: string | null; state: string | null; returnTo: string } => {
  const verifier = window.sessionStorage.getItem(VERIFIER_KEY);
  const state = window.sessionStorage.getItem(STATE_KEY);
  const returnTo = window.sessionStorage.getItem(RETURN_TO_KEY) || '/account';
  window.sessionStorage.removeItem(VERIFIER_KEY);
  window.sessionStorage.removeItem(STATE_KEY);
  window.sessionStorage.removeItem(RETURN_TO_KEY);
  return { verifier, state, returnTo };
};
